/**
 * Модуль для работы с видео попапом
 */

/**
 * Инициализирует видео попап
 */
export function initVideoPopup() {
  const videoButtons = document.querySelectorAll('.open-video-popup')
  const videoPopup = document.getElementById('popup-video')

  if (!videoButtons.length || !videoPopup) return

  const videoElement = videoPopup.querySelector('video')
  const closeBtn = videoPopup.querySelector('.popup__close')
  const overlay = videoPopup.querySelector('.popup__overlay')

  function openVideoPopup() {
    videoPopup.classList.add('active')
    document.body.style.overflow = 'hidden'

    // Lazy load video source
    if (videoElement && !videoElement.getAttribute('src')) {
      const videoSrc = videoElement.getAttribute('data-src')
      if (videoSrc) {
        videoElement.setAttribute('src', videoSrc)
      }
    }

    // Auto play when opened
    if (videoElement) {
      videoElement.play().catch((e) => {
        console.warn('Auto-play prevented:', e)
      })
    }
  }

  function closeVideoPopup() {
    videoPopup.classList.remove('active')
    document.body.style.overflow = ''

    // Pause video when closed
    if (videoElement) {
      videoElement.pause()
      videoElement.currentTime = 0 // Reset to beginning
    }
  }

  videoButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      openVideoPopup()
    })
  })

  if (closeBtn) {
    closeBtn.addEventListener('click', closeVideoPopup)
  }

  if (overlay) {
    overlay.addEventListener('click', closeVideoPopup)
  }

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && videoPopup.classList.contains('active')) {
      closeVideoPopup()
    }
  })
}




